import React from 'react';
import { CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="py-12 md:py-16 bg-gradient-to-b from-white to-gray-50" data-id="element-166">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 mb-8 text-center" data-id="element-168">
          <p className="text-red-700 font-bold text-sm md:text-base" data-id="element-169">
            ⚠️ 185.622 Aufrufe | Eilmeldung
          </p>
        </div>
        <div className="text-center mb-10" data-id="element-170">
          <div className="flex justify-center mb-6" data-id="element-171">
            {[1, 2, 3, 4].map(star => <svg key={star} className="w-7 h-7 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-172">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-173" />
              </svg>)}
            <svg className="w-7 h-7 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" style={{
            clipPath: 'inset(0 50% 0 0)'
          }} data-id="element-174">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-175" />
            </svg>
          </div>
          <p className="text-sm md:text-base text-gray-600 font-medium mb-8" data-id="element-176">
            4,8 von 5 Sternen • 1.247 Bewertungen
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-8 leading-tight max-w-5xl mx-auto" data-id="element-177">
            DURCHBRUCH: Klinisch bewiesen – 94% der Frauen berichten von
            sichtbaren Ergebnissen in nur 14 Tagen
          </h2>
          <div className="max-w-3xl mx-auto mb-6" data-id="element-178">
            <p className="text-xl md:text-2xl text-emerald-700 font-semibold mb-4" data-id="element-179">
              Das vegane Protein, das Ärzte empfehlen
            </p>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed italic" data-id="element-180">
              "Nach nur 2 Wochen konnte ich sehen, dass meine Haut straffer und
              meine Muskeln definierter sind – ich hätte nie gedacht, dass
              pflanzliches Protein so schnell wirkt!"
            </p>
          </div>
        </div>
        <div className="space-y-5 mb-10 max-w-4xl mx-auto" data-id="element-181">
          <div className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-182">
            <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 rounded-full text-white flex items-center justify-center mt-1" data-id="element-183">
              <CheckIcon className="h-5 w-5" data-id="element-184" />
            </div>
            <p className="ml-4 text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-185">
              <strong className="font-semibold text-gray-900" data-id="element-186">
                SCHNELLE ERGEBNISSE:
              </strong>{' '}
              87% der Anwenderinnen berichten von ersten sichtbaren
              Veränderungen innerhalb von 7-14 Tagen
            </p>
          </div>
          <div className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-187">
            <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 rounded-full text-white flex items-center justify-center mt-1" data-id="element-188">
              <CheckIcon className="h-5 w-5" data-id="element-189" />
            </div>
            <p className="ml-4 text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-190">
              <strong className="font-semibold text-gray-900" data-id="element-191">
                KLINISCH BEWIESEN:
              </strong>{' '}
              +20,2% Muskeldicke und +8,8% mehr Kraft in 12 Wochen – identisch
              zu Whey-Protein, aber 100% vegan
            </p>
          </div>
          <div className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-192">
            <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 rounded-full text-white flex items-center justify-center mt-1" data-id="element-193">
              <CheckIcon className="h-5 w-5" data-id="element-194" />
            </div>
            <p className="ml-4 text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-195">
              <strong className="font-semibold text-gray-900" data-id="element-196">
                KEINE BLÄHUNGEN:
              </strong>{' '}
              +36% mehr gesunde Darmbakterien durch präbiotische Ballaststoffe –
              94% berichten von besserer Verträglichkeit
            </p>
          </div>
          <div className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-197">
            <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 rounded-full text-white flex items-center justify-center mt-1" data-id="element-198">
              <CheckIcon className="h-5 w-5" data-id="element-199" />
            </div>
            <p className="ml-4 text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-200">
              <strong className="font-semibold text-gray-900" data-id="element-201">
                ABNEHMEN LEICHT GEMACHT:
              </strong>{' '}
              +40% mehr Sättigung und durchschnittlich -1,8kg Körperfett in 8
              Wochen
            </p>
          </div>
          <div className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-202">
            <div className="flex-shrink-0 w-8 h-8 bg-emerald-600 rounded-full text-white flex items-center justify-center mt-1" data-id="element-203">
              <CheckIcon className="h-5 w-5" data-id="element-204" />
            </div>
            <p className="ml-4 text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-205">
              <strong className="font-semibold text-gray-900" data-id="element-206">
                DEUTSCHLANDS #1:
              </strong>{' '}
              54.000+ glückliche Kundinnen – 5x Testsieger in Folge
            </p>
          </div>
        </div>
        <div className="bg-amber-50 border-2 border-amber-300 rounded-xl p-6 md:p-8 mb-10 max-w-3xl mx-auto shadow-sm" data-id="element-207">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-208">
            🚨 WARNUNG: Ihr Körper verliert JETZT GERADE Muskelmasse
          </h3>
          <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-209">
            Ab 35 verlieren Frauen 3-8% Muskelmasse PRO JAHRZEHNT. Das bedeutet:
            Weniger Energie, schwächere Knochen, mehr Körperfett.
          </p>
          <p className="text-gray-900 font-semibold leading-relaxed" data-id="element-210">
            Aber hier ist die gute Nachricht: Deutsche Wissenschaftlerinnen
            haben eine Protein-Formel entwickelt, die diesen Prozess nicht nur
            stoppt, sondern UMKEHRT.
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-211">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2NhgRhQe5DCaouxCboiqer/Screenshot_2025-11-17_at_14.49.05.png" alt="TESTSIEGER - VerbraucherVergleich SEHR GUT (9.7) - eve nutrition Nourishing Vanilla Protein" className="w-full h-auto rounded-xl shadow-lg" data-id="element-212" />
        </div>
      </div>
    </section>;
}